import { render, staticRenderFns } from "./DangerZone.vue?vue&type=template&id=e4ba7ccc&"
import script from "./DangerZone.vue?vue&type=script&lang=js&"
export * from "./DangerZone.vue?vue&type=script&lang=js&"
import style0 from "./DangerZone.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DangerZone.vue"
export default component.exports